/**
 *constants.js
 * Various static exports
 **/
export const VIDEO_EXTENSIONS = [
  'm3u8',
  'ts',
  'm2ts',
  'mts',
  'mov',
  'mkv',
  'mp4',
  'mpeg',
  'mpd',
];
export const IMAGE_EXTENSIONS = [
  'ai',
  'gif',
  'png',
  'webp',
  'avif',
  'bmp',
  'eps',
  'ps',
  'eps3',
  'ept',
  'fbx',
  'flif',
  'glb',
  'gltf',
  'heif',
  'heic',
  'ico',
  'jpg',
  'jpe',
  'jpeg',
  'jp2',
  'wdp',
  'hdp',
  'jxr',
  'pdf',
  'png',
  'svg',
  'tif',
  'tiff',
  'webp',
];
export const musicfoxLogoSrcLightUi =
  'https://cdn.sanity.io/images/m7ui67sm/production/f02595607a3023b5e83b62b1038889c19a868363-885x167.png?&h=60';
export const musicfoxLogoSrcDarkUi =
  'https://cdn.sanity.io/images/m7ui67sm/production/1d3667a1dfb7bb2a70293aa3ef639f2449335f82-885x167.png?&h=60';
export const fratoniFace =
  'https://cdn.sanity.io/images/m7ui67sm/production/a49095558c1284b081475c34ab8ab86c14032c51-803x802.jpg?w=500&h=500&fit=max';
export const demoAvatarImg =
  'https://cdn.sanity.io/images/m7ui67sm/production/2da66d00a51dbbcd1ea5e765808bb440bc2b3464-512x512.png?w=512&h=512&fit=max';
export const demoAvatarDarkImg =
  'https://cdn.sanity.io/images/m7ui67sm/production/70367ecd062407510d048628ed87e6672e543951-512x512.png?w=500&h=500&fit=max';
export const heroBackgroundImageDefault =
  'https://cdn.sanity.io/images/8du83upr/production/0c59a37d340a11fb8e9ece673fbaaf0832354e28-3840x2564.png?w=3000&h=3000&fit=max';

export const mediaQueries = {
  small: '(max-width: 599px)',
  medium: '(min-width: 600px) and (max-width: 1199px)',
  large: '(min-width: 1200px)',
};

export const BIZ_URL = {
  external: 'https://musicfox.io',
  internal: '/',
};
